<template>
  <Modal max-width="400" title="Você atingiu o limite de sites" title-section-mobile="Você atingiu o limite de sites" controlsDirection="right">
    <p class="text-caption">{{modalContent.subTitle}}</p>
    <template #append>
      <Button color="primary" label="Talvez outra hora" text @click="toggleModal"/>
      <Button v-bind="buttonProps" @click="changePlan"/>
    </template>
  </Modal>
</template>

<script>
import { Button, Modal } from '@locaweb/design-system-vue'
export default {
  components: { Button, Modal },
  props: ['filteredData', 'idSite'],
  data () {
    return {
      filteredSite: {}
    }
  },
  methods: {
    findFilteredSite () {
      this.filteredSite = this.filteredData[0]
    },
    toggleModal () {
      this.$emit('closeCancel')
    },
    changePlan () {
      window.open(this.modalContent.redirect, '_blank')
      this.toggleModal()
    }
  },
  computed: {
    cantUpgrade () {
      return (this.filteredSite.plan_key === 'SVNHOWP0006') || (this.filteredSite.plan_key === 'SVNHOWP0006')
    },

    modalContent () {
      const content = {
        false: {
          subTitle: 'Faça um upgrade de plano para ter mais sites.',
          titleButton: 'Fazer upgrade do plano',
          redirect: `${process.env.VUE_APP_CENTRAL_URL}/planos/00000000${this.filteredSite.provisioning_id}/alterar-plano`
        },
        true: {
          subTitle: 'Contrate um novo plano de hospedagem Wordpress no nosso site.',
          titleButton: 'Contratar novo plano',
          redirect: `${process.env.VUE_APP_LOCAWEB_URL}/hospedagem-wordpress/`
        }
      }
      return content[this.cantUpgrade]
    },
    buttonProps () {
      const items = {
        label: this.modalContent.titleButton,
        color: 'primary'
      }

      return items
    }
  },
  mounted () {
    this.findFilteredSite()
  }
}
</script>
